import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    [theme.breakpoints.down('xs')]: {
      flexWrap: 'wrap',
    }
  },
  title: {
    flexGrow: 1,
  }
}));

export default function CompanyAppBar(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMyAccount = () => {
    setAnchorEl(null);
    props.onMyAccount();
  };

  const handleLogout = () => {
    setAnchorEl(null);
    props.onLogout();
  };

  const handleLogin = () => {
    setAnchorEl(null);
    props.onLogin();
  };

  const classes = useStyles();
  return (<AppBar position="static" color="transparent" elevation={0} style={{marginBottom: 0}}>
    <Toolbar className={classes.root}>
      {props.onBackClick ?
      <IconButton edge="start" color="inherit" aria-label="back" onClick={props.onBackClick}>
        <ArrowBackIosIcon />
      </IconButton>: '' }
      { props.title ?
      <Typography variant="h6" className={classes.title} >
        {props.title}
      </Typography> : '' }
      {props.children}
      <Button style={{whiteSpace: 'nowrap'}} edge="end" aria-label="profile" onClick={handleClick} endIcon={<AccountCircleIcon />}>
        My Profile
      </Button>
    </Toolbar>
    <Menu
      id="account-menu"
      anchorEl={anchorEl}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={handleClose}
      style={{marginTop: 40}}
    >
      { props.profile ?
      [
        <MenuItem key="account" onClick={handleMyAccount}>My Account</MenuItem>,
        <MenuItem key="logout" onClick={handleLogout}>Logout</MenuItem>
        ]
      :
      <MenuItem key="login" onClick={handleLogin}>Login</MenuItem>
      }
    </Menu>
  </AppBar>)
}
